import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  MenuDescription,
} from "../ui/dropdown-menu";
import type { AuthUser } from "../../auth/auth";
import { NotificationSoundsItem } from "./NotificationSoundsItem";

// One shared user-menu body for the dock avatar menu (AccountControl) and the
// greeting-header menu (HomeAccount). Only the trigger, modality and content
// placement stay per caller.
export function UserMenuContent({ user, onSignOut }: { user: AuthUser; onSignOut: () => void }) {
  const { t } = useTranslation();
  return (
    <>
      <DropdownMenuLabel>
        <strong className="block truncate">{user.name}</strong>
        <MenuDescription className="truncate">
          {user.email ||
            t(user.provider === "development" ? "auth.mockAccount" : "auth.googleAccount")}
        </MenuDescription>
      </DropdownMenuLabel>
      <DropdownMenuSeparator />
      <NotificationSoundsItem />
      <DropdownMenuSeparator />
      <DropdownMenuItem variant="destructive" onSelect={onSignOut}>
        <LogOut />
        {t("auth.signOut")}
      </DropdownMenuItem>
    </>
  );
}
